import React from "react";
import { Modal } from "react-bootstrap";

import { useDispatch } from "react-redux";

import { deleteExistingMapping } from "../../store/slice/mappingSlice";

import { useCmsHook } from "../../helpers/cmsHook";

const DeleteModal = ({ show, hideDeleteModal }) => {
  const { cmsInstance } = useCmsHook();
  const dispatch = useDispatch();
  return (
    <div>
      <Modal
        className="my-modal"
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="delete-modal p-4">
          {/* <p className="delete-modal-message">
            Are you sure you want to delete this property?
          </p> */}
          {cmsInstance &&
            cmsInstance.showRichText(
              "cmsContent.notifications.mappingWindow.successContent.deleteMapping.message",
              "delete-modal-message"
            )}
          <div className="d-flex flex-row justify-content-end mt-3">
            <button
              className="me-3 delete-modal-cancel-btn"
              onClick={hideDeleteModal}
            >
              Cancel
            </button>
            <button
              className="delete-modal-delete-btn"
              onClick={() => {
                dispatch(deleteExistingMapping());
                hideDeleteModal();
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteModal;
